import { render, staticRenderFns } from "./SchoolSetting.vue?vue&type=template&id=3ebd7129&"
import script from "./SchoolSetting.vue?vue&type=script&lang=ts&"
export * from "./SchoolSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports